import { Routes, Route } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';

import { NotFoundPage } from '@/pages/NotFoundPage';
import {
  AccountStatementPage,
  BetListReportPage,
  BonusReportPage,
  CasinoPage,
  CasinoPlaygroundPage,
  DepositPage,
  DepositReportPage,
  EventDetailsPage,
  FavouritesPage,
  HomePage,
  ProfilePage,
  ProfitLossReportPage,
  ReferralPage,
  SportsPage,
  UserPage,
  WithdrawPage,
  WithdrawReportPage,
  RulesPage,
} from '@/routes';
import MainLayout from '@/layouts/MainLayout';
import ProfileLayout from '@/layouts/ProfileLayout';
import { ScrollToTop } from '@/utils/ScrollToTop';
import MaintenancePage from './pages/MaintenancePage';
export function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }
  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}></Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/sport" element={<SportsPage />} />
          <Route path="/sport/upcoming-events" element={<SportsPage />} />
          <Route path="/sport/inplay-events" element={<SportsPage />} />
          <Route path="/sport/favourites" element={<FavouritesPage />} />
          <Route path="/sport/event-details/:eventId" element={<EventDetailsPage />} />
          <Route path="/user" element={<UserPage />} />
          <Route path="/casino" element={<CasinoPage />} />
          <Route path="/casino-playground" element={<CasinoPlaygroundPage />} />
          <Route element={<ProfileLayout />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/deposit" element={<DepositPage />} />
            <Route path="/withdraw" element={<WithdrawPage />} />
            <Route path="/account-statement" element={<AccountStatementPage />} />
            <Route path="/deposit-report" element={<DepositReportPage />} />
            <Route path="/withdraw-report" element={<WithdrawReportPage />} />
            <Route path="/pl-report" element={<ProfitLossReportPage />} />
            <Route path="/bet-history" element={<BetListReportPage />} />
            <Route path="/bonus-report" element={<BonusReportPage />} />
            <Route path="/referrals" element={<ReferralPage />} />
          </Route>
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}></Route>
        <Route path="/rules" element={<RulesPage />}></Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
